<footer>

    <div class="copyright">Copyright 2020 Poll Ninja</div>

</footer>

<style>
    footer{
        
        padding: 40px 0;
    }
    .copyright{
        font-size: 14px;
        width:max-content;
        color: #aaa;
        padding: 15px;
        border-top: 1px solid #ddd;
        margin: 0 auto;
    }

</style>